<template>
  <PageTable />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-awsSample-fabricReview',
  components: { PageTable },
}
</script>
